module.exports = __webpack_public_path__ + "static/media/1022133.91fed40a.jpg";